import type { UserNotificationStatus } from 'dynamo-daos/build/models/misc/userNotificationRecord';
import type { UserNotificationType } from 'dynamo-daos/build/models/misc/userNotificationProperties';

import type { UserNotification } from '../types';
import apiRequest from './apiRequest';

type GetNotificationsResponse = {
  records: UserNotification[];
  nextToken?: string;
};

export default async function getNotifications({
  limit,
  nextToken,
  notificationType,
  status,
}: {
  limit?: number;
  nextToken?: string;
  notificationType?: UserNotificationType;
  status?: UserNotificationStatus;
} = {}) {
  const urlParams = new URLSearchParams();
  if (limit !== undefined) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (notificationType) {
    urlParams.set('notificationType', notificationType);
  }
  if (status) {
    urlParams.set('status', status);
  }

  const query = urlParams.toString();

  return apiRequest<GetNotificationsResponse>(
    'user',
    `/users/notifications${query ? `?${query}` : ''}`,
  );
}
